import type { ReactNode } from 'react';
import { cn } from '@herit-fe/heritage-ui';

export interface CardProps {
  /**
   * 선택 제목 — 카드 상단 소제목 h2(없으면 미렌더). `ReactNode` 라 제목 옆 보조 표기(예: 조회 기준일을 muted
   * 로 덧붙이기)를 그대로 넘길 수 있다.
   */
  title?: ReactNode;
  /** 제목 우측 액션 슬롯(선택) — 예: 설치사진 보기 버튼. `title` 있을 때만 헤더 렌더. */
  action?: ReactNode;
  /** 외곽 section 에 병합할 추가 클래스. */
  className?: string;
  children: ReactNode;
}

/**
 * 카드 chrome 프리미티브 — `rounded-xl border bg-card p-4` 외곽 + 선택 제목(+우측 액션). 본문 톤을 강제하지
 * 않아 폼·정의목록·표·차트 등 아무 블록이나 담는다(muted 설명 톤·큰 제목이 필요하면 `RegionCard`). 도처에
 * 흩어진 인라인 카드 chrome 의 SSOT. `action` 이 있으면 제목 행이 flex(제목 좌·액션 우)로 바뀐다.
 */
export function Card({ title, action, className, children }: CardProps) {
  return (
    <section className={cn('rounded-xl border border-border bg-card p-4', className)}>
      {title != null && (
        // action 없으면 제목만(기존 높이 유지) — action 있을 때만 버튼이 행 높이를 정한다(title-only 카드 리듬 불변).
        <div className="mb-3 flex items-center justify-between gap-2">
          <h2 className="text-sm font-semibold text-foreground">{title}</h2>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}
